import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ProgressStep } from '../../models.progress-step/progress-step';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css'],
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  @Output() completed = new EventEmitter<void>();
  @Input() autoSimulate = true;
  /** Con `autoSimulate` en true, valor simulado o externo. Con false, se ignora y se deriva de `steps`. */
  @Input() progress = 0;
  @Input() steps: ProgressStep[] = [
    { label: 'Validando datos', status: 'completed' },
    { label: 'Preparando plantilla', status: 'completed' },
    { label: 'Llenando variables', status: 'in-progress' },
    { label: 'Generando anexos', status: 'pending' },
    { label: 'Ajustando documento', status: 'pending' },
    { label: 'Adjuntando a la solicitud', status: 'pending' },
  ];

  intervalId!: number;

  /** Modo de la barra Material: animación mientras hay un paso en curso (carga real). */
  get progressBarMode(): 'determinate' | 'indeterminate' {
    if (this.autoSimulate) {
      return 'determinate';
    }
    return this.steps?.some((s) => s.status === 'in-progress')
      ? 'indeterminate'
      : 'determinate';
  }

  /** Valor 0–100 coherente con los pasos (solo en modo determinate). */
  get progressBarValue(): number {
    if (this.autoSimulate) {
      return Math.min(100, Math.max(0, this.progress));
    }
    if (this.progressBarMode === 'indeterminate') {
      return 0;
    }
    return this.computeProgressFromSteps();
  }

  /** Texto auxiliar: qué subproceso está activo (si hay error, no mezclar con otro paso «en curso»). */
  get activeStepCaption(): string {
    if (this.autoSimulate) {
      return '';
    }
    const steps = this.steps ?? [];
    const err = steps.find((s) => s.status === 'error');
    if (err) {
      return `Revisar: ${err.label}`;
    }
    const cur = steps.find((s) => s.status === 'in-progress');
    return cur ? `En curso: ${cur.label}` : '';
  }

  private computeProgressFromSteps(): number {
    const steps = this.steps ?? [];
    const n = steps.length || 1;
    let units = 0;
    for (const s of steps) {
      if (s.status === 'completed') {
        units += 1;
      } else if (s.status === 'in-progress') {
        units += 0.45;
        break;
      } else if (s.status === 'error') {
        units += 0.35;
        break;
      } else {
        break;
      }
    }
    return Math.min(100, Math.round((units / n) * 100));
  }

  ngOnInit(): void {
    if (this.autoSimulate) {
      this.startSimulation();
    }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startSimulation() {
    const stepDuration = 2000;
    const progressStep = 100 / this.steps.length;

    let currentStep = 2;

    this.intervalId = window.setInterval(() => {
      // // 🔴 SIMULAMOS ERROR EN EL PASO 3
      // if (currentStep === 3) {
      //   this.steps[currentStep].status = 'error';
      //   this.steps[currentStep].errorMessage =
      //     'No fue posible generar los anexos';

      //   clearInterval(this.intervalId);
      //   return; // 🔴 se detiene el flujo
      // }

      if (currentStep >= this.steps.length) {
        this.progress = 100;
        clearInterval(this.intervalId);
        this.completed.emit();
        return;
      }

      this.steps[currentStep].status = 'completed';

      if (this.steps[currentStep + 1]) {
        this.steps[currentStep + 1].status = 'in-progress';
      }

      this.progress += progressStep;
      currentStep++;
    }, stepDuration);
  }
}
